const listOfConference = [
  {
    id: 1,
    year: 2021,
    submenu: [
      {
        author:
          "Aysen Degerli, Mete Ahishali, Serkan Kiranyaz, Muhammad E. H. Chowdhury, Moncef Gabbouj, ",
        title: `Reliable Covid-19 Detection using Chest X-Ray Images `,
        details:
          "in 2021 IEEE International Conference on Image Processing (ICIP) 19-22 Sept. 2021, 10.1109/ICIP42928.2021.9506442",
        doi: "https://ieeexplore.ieee.org/document/9506442",
      },
      {
        author:
          "Aradhya, VN Manjunath, Mufti Mahmud, M. Chowdhury, D. S. Guru, M. Shamim Kaiser, and Saiful Azad. pp. 241-244. IEEE, 2021.",
        title: `Learning Through One Shot: A Phase by Phase Approach for COVID-19 Chest X-ray Classification.`,
        details:
          "In 2020 IEEE-EMBS Conference on Biomedical Engineering and Sciences (IECBES) pp. 241-244. IEEE, 2021.",
        doi: "https://ieeexplore.ieee.org/document/9398761",
      },
    ],
  },
  {
    id: 2,
    year: 2020,
    submenu: [
      {
        author:
          "Abualsaud, Khalid, Muhammad EH Chowdhury, Abdurrazzak Gehani, Elias Yaacoub, Tamer Khattab, and Jamal Hammad.",
        title:
          "A New Wearable ECG Monitor Evaluation and Experimental Analysis: Proof of Concept.",
        details:
          "In 2020 International Wireless Communications and Mobile Computing (IWCMC) pp. 1885-1890. IEEE, 2020.",
        doi: "https://doi.org/10.1109/IWCMC48107.2020.9148191",
      },
      {
        author:
          "Abdularahman Abunada, Mr. Ahmed Osman, Mr. Amith Khandakar, Muhammad Chowdhury, Tamer Khattab, Farid Touati",
        title: "Design and Implementation of a RF Based Anti-Drone System",
        details:
          "2020 IEEE International Conference on Informatics, IoT, and Enabling Technologies (ICIoT) 2-5 February, 2020.",
        doi: "https://doi.org/10.1109/ICIoT48696.2020.9089515",
      },
      {
        author:
          "ANM Tawsifur Rahman, Muhammad EH Chowdhury, Zaid Bin Mahbub, Muhammad Abdul Kadir.",
        title:
          "Driver drowsiness detection by heart rate variability (HRV) analysis using machine-learning algorithm",
        details: " ICPM conference, vol. 10, Issue 9, 2020",
        doi: "",
      },
    ],
  },
  {
    id: 3,
    year: 2019,
    submenu: [
      {
        author:
          "Moajjem Hossain Chowdhury, Md Nazmul Islam Shuzan, Muhammad E.H. Chowdhury, Zaid B Mahbub, M. Monir Uddin, ",
        title: `Relation between demographic data and Photoplethysmography (PPG) signal features in estimating human health metrics`,
        details: "December 27-29, ICAS 2019.",
        doi: "https://doi.org/10.48550/arXiv.2102.09483",
      },
    ],
  },
  {
    id: 4,
    year: 2018,
    submenu: [
      {
        author:
          "Muhammad E.H. Chowdhury, Khawla Alzoubi, Ridab Khalifa, Sirine Koubaa, Rayaan Abouhashera, ",
        title: `Wearable Real Time Heart Attack Detection and Warning System to Reduce Car Accidents in Qatar`,
        details:
          "in the annual research conference 2018 in Qatar, 19-20 March.",
        doi: "https://doi.org/10.5339/qfarc.2018.HBPD246",
      },
      {
        author:
          "Muhammad E.H. Chowdhury, Adham Osman, Samir El Behri, Ahmed Mustafa, Osama Halabi, Serkan Kiranyaz",
        title: `Driver Drowsiness Detection Study using Heart Rate Variability analysis in Virtual Reality Environment`,
        details:
          "in the annual research conference 2018 in Qatar, 19-20 March.",
        doi: "https://doi.org/10.5339/qfarc.2018.ICTPD1132",
      },
    ],
  },
  {
    id: 5,
    year: 2017,
    submenu: [
      {
        author: "M. E. H. Chowdhury, Ridab khallifa, Sirine Koubaa (2017),",
        title: `Wearable Real-Time Heart Attack and Epileptic Seizure Detection and Warning System to Reduce Car Accidents in Qatar`,
        details:
          "Honors Program Research Day, Qatar University, Doha, 24 May 2017.",
        doi: "https://doi.org/10.3390/s19122780",
      },
    ],
  },
  {
    id: 6,
    year: 2016,
    submenu: [
      {
        author:
          "G. Spencer, M. E. H. Chowdhury, K. J. Mullinger, R. W. Bowtell (2016)",
        title: `Detecting visual evoked responses in simultaneous EEG-fMRI using Reference Layer Artefact Subtraction (RLAS).`,
        details:
          "24th Annual Meeting and Exhibition of the ISMRM Abstract#3775, Singapore, 07-13 May 2016.",
        doi: "",
      },
    ],
  },
  {
    id: 7,
    year: 2015,
    submenu: [
      {
        author:
          "M. E. H. Chowdhury, K. J. Mullinger, R. W. Bowtell (2015), Abstract#3226, Toronto, Canada.",
        title: `“Simultaneous EEG-fMRI: evaluating the effect of the EEG cap cabling configuration on the gradient artefact.” 23th Annual Meeting and Exhibition of the ISMRM`,
        details: "",
        doi: "",
      },
      {
        author:
          "M. E. H. Chowdhury, K. J. Mullinger, G.S. Spencer, R. W. Bowtell (2015), Abstract#3248, Toronto, Canada.",
        title: `“Removing the gradient artefact caused by 3D EPI in simultaneous EEG-fMRI experiments using a gradient model fit.” 23th Annual Meeting and Exhibition of the ISMRM`,
        details: "",
        doi: "",
      },
      {
        author:
          "E.H. Bhuiyan, M. E. H. Chowdhury, P. M. Glover, R. W. Bowtell (2015), Abstract#6072, Toronto, Canada.",
        title: ` “Movement Monitoring for MRI via Measurement of Changes in the Gradient Induced EMF in Coil Arrays.” 23th Annual Meeting and Exhibition of the ISMRM`,
        details: "",
        doi: "",
      },
    ],
  },

  {
    id: 8,
    year: 2013,
    submenu: [
      {
        author:
          "Chowdhury, M. E. H, Karen J. Mullinger, Paul M. Glover, Richard W. Bowtell (2013), Abstract#47935, Toulouse, France.",
        title: ` “Reference Layer Artefact Subtraction (RLAS): a novel method of minimizing EEG artefacts during simultaneous fMRI”, 19th Annual Meeting of the Organization for Human Brain Mapping`,
        details: "",
        doi: "",
      },
      {
        author:
          "Chowdhury, M. E. H., Mullinger, K. J., Antunes, A., Glover, P.M. and Bowtell, R. W. (2013), “A novel method of minimizing EEG artefacts during simultaneous fMRI: a simulation study”, 19th Annual Meeting of the Organization for Human Brain Mapping, Abstract#47937, Toulouse, France.",
        title: `“A novel method of minimizing EEG artefacts during simultaneous fMRI: a simulation study”, 19th Annual Meeting of the Organization for Human Brain Mapping`,
        details: "",
        doi: "",
      },
      {
        author:
          "Chowdhury, M. E. H, Karen J. Mullinger, Paul M. Glover, Richard W. Bowtell (2013), Abstract#1242, Seattle, USA.",
        title: `“Reference Layer Artefact Subtraction (RLAS): a novel method of minimizing EEG artefacts during simultaneous fMRI”, 19th Annual Meeting of the Organization for Human Brain Mapping`,
        details: "",
        doi: "",
      },
      {
        author:
          "Chowdhury, M. E. H., Mullinger, K. J., Antunes, A., Glover, P.M. and Bowtell, R. W. (2013), Abstract#1783, Seattle, USA.",
        title: `“A novel method of minimizing EEG artefacts during simultaneous fMRI: a simulation study”, 19th Annual Meeting of the Organization for Human Brain Mapping`,
        details: "",
        doi: "",
      },
      {
        author:
          "K. J. Mullinger, M.E.H. Chowdhury, R. Bowtell (2013), Abstract#2763, Salt lake, USA.",
        title: ` “Reducing the gradient artefact in simultaneous EEG-fMRI by adjusting the EEG cap lead configuration” 21st Annual Meeting and Exhibition of the ISMRM`,
        details: "",
        doi: "",
      },
      {
        author:
          "Chowdhury, M. E. H., Mullinger, K. J., Antunes, A., Glover, P.M. and Bowtell, R. W. (2013), Abstract#20, London, UK.",
        title: `“A novel method of minimizing EEG artefacts during simultaneous fMRI: a simulation study”, 22nd British Chapter ISMRM Postgraduate Symposium`,
        details: "",
        doi: "",
      },
    ],
  },
  {
    id: 9,
    year: 2012,
    submenu: [
      {
        author:
          "M. E. H. Chowdhury, K. J. Mullinger, R. W. Bowtell (2012), Abstract#13, Budapest, Hungary.",
        title: `“Reference Layer Artefact Subtraction (RLAS): a novel method of minimizing EEG artefacts during simultaneous fMRI” ERNI-HSF Budapest Meeting 'Brain Oscillations in Health and Disease'`,
        details: "",
        doi: "",
      },
      {
        author:
          "M. E. H. Chowdhury, K. J. Mullinger, R. W. Bowtell (2012). Abstract#3965, Melbourne, Australia",
        title: `“Reference Layer Artefact Subtraction (RLAS): a novel method of minimizing EEG artefacts during simultaneous fMRI” 20th Annual Meeting and Exhibition of the ISMRM`,
        details: "",
        doi: "",
      },
      {
        author:
          "M. E. H. Chowdhury, K. J. Mullinger, R. W. Bowtell (2012), Abstract#2322, Melbourne, Australia.",
        title: `“Simultaneous EEG-fMRI: Gradient artefact reduction through cabling configuration” 20th Annual Meeting and Exhibition of the ISMRM`,
        details: "",
        doi: "",
      },
      {
        author:
          "M. E. H. Chowdhury, K. J. Mullinger, R. W. Bowtell (2012), Abstract#05, Bristol, UK.",
        title: `“Reference Layer Artefact Subtraction (RLAS): a novel method of minimizing EEG artefacts during simultaneous fMRI” 21st British Chapter ISMRM Postgraduate Symposium`,
        details: "",
        doi: "",
      },
    ],
  },
  {
    id: 10,
    year: 2011,
    submenu: [
      {
        author:
          "M. E. H. Chowdhury, K. J. Mullinger, R. W. Bowtell (2011), Abstract#06, Galway, Ireland.",
        title: `“Simultaneous EEG-fMRI: Gradient artefact reduction through cabling configuration” in the preceding of Combining Human Brain Imaging techniques`,
        details: "",
        doi: "",
      },
      {
        author:
          "M. E. H. Chowdhury, K. J. Mullinger, R. W. Bowtell (2011), Abstract#29, Manchester, UK. ",
        title: `“Simultaneous EEG-fMRI: Gradient artefact reduction through cabling configuration” 17th British Chapter ISMRM annual meeting`,
        details: "",
        doi: "",
      },
    ],
  },
  {
    id: 11,
    year: 2010,
    submenu: [
      {
        author:
          "Rabeya Ferdousy, Anisul Islam Choudhory, Md. Shafiul Islam, Md. Afzalur Rab , Md. Enamul Hoque Chowdhury, 2-4 Nov. 2010. p. 163-167.",
        title: `“Electrooculographic and Electromyographic Artifacts Removal from EEG” in the 2010 2nd International Conference on Chemical, Biological and Environmental Engineering (ICBEE 2010)`,
        details: "",
        doi: "",
      },
      {
        author:
          "Md. Shafiqur Rahman, Susmita Ghose, Zamshed Iqbal Chowdhury, Md. Abu Al Beruni, Md.Enamul Haque Chowdhury,Hangzhou,china,October 5-6,2010,Vol-1,pp 184-188.",
        title: ` “Design and implementation of a Remote Data Acquisition System based on SMS” in the proceedings of International conference on remote sensing (ICRS)`,
        details: "",
        doi: "",
      },
      {
        author:
          "Md. Shafiul Islam, Md. Belayat Hossain, Md. Nahid Hossain, Saadia Binte Alam and Md. Enamul Hoque Chowdhury, San Francisco, USA, 20-22 October, 2010, vol-2, pp-863-867.",
        title: `“Modeling of a Double-Layer Capacitor with Individual Branch Response”in the proceedings of World Congress on Engineering and Computer Science  (WCECS) organized by the International Association of Engineers (IAENG)`,
        details: "",
        doi: "",
      },
      {
        author:
          "Sadeque Reza Khan, Md. Zahir Uddin Chowdhury, Md. Enamul Hoque Chowdhury, abstract# ICS-02, at Dhaka, 2010.",
        title: `Design and Implementation of Digital Irrigation System for efficient water utilization”, in Proceedings of Annual Conference and Seminar on “Electronics and Telecommunications for Digital Bangladesh`,
        details: "",
        doi: "",
      },
      {
        author:
          "Rabeya Ferdousy, Olly Roy Chow., Md. Enamul Hoque Chow., S. K. Aditya, abstract# E1-02, at Dhaka, 2010.",
        title: `“SOBI and BSS-CCA Applied to Remove Electroocular and Electromyographic Artifacts from the Electroencephalogram”, in Proceedings of Annual Conference and Seminar on “Electronics and Telecommunications for Digital Bangladesh”`,
        details: "",
        doi: "",
      },
    ],
  },
  {
    id: 12,
    year: 2009,
    submenu: [
      {
        author: "Abdullah Al Mamun and Md. Enamul Hoque, pp 123-128, 2009.",
        title: ` “Wireless Transmission of Electricity-Development and Review of the Current Research Activities”,  in Proceedings of 2nd International Conference on Engineering Education for sustainable development`,
        details: "",
        doi: "",
      },
    ],
  },
];
export default listOfConference;
